import React from "react";
import "../styles/Reels.scss";
import { Link } from "react-router-dom";

import ReactFreezeframe from "react-freezeframe";
import Header from "./Header";
import Footer from "./Footer";

class CollectiveReels extends React.Component {
  render() {
    return (
      <div>
        <Header />
        <div className={`container ${this.props.json}`}>
          <h1 className="heading serif-font">
            Collective Reels
            <span className="serif-italic-font">{this.props.title}</span>
          </h1>
          <div className="reels-thumbs">
            {
              <React.Fragment>
                <Link
                  to={`${process.env.PUBLIC_URL}/collective-reel`}
                  className="reels-thumb"
                  key="reel-collective"
                >
                  <div className="reels-thumb-image">
                    <ReactFreezeframe
                      src={`${process.env.PUBLIC_URL}/images/film/collective.gif`}
                    />
                  </div>
                  <div className="reels-thumb-text">
                    <h3>Estelle Collective</h3>
                    <h5>Reel</h5>
                  </div>
                </Link>
                <Link
                  to={`${process.env.PUBLIC_URL}/reel-2020`}
                  className="reels-thumb"
                  key="reel-2020"
                >
                  <div className="reels-thumb-image">
                    <ReactFreezeframe
                      src={`${process.env.PUBLIC_URL}/images/film/reel2020.gif`}
                    />
                  </div>
                  <div className="reels-thumb-text">
                    <h3>Estelle Collective</h3>
                    <h5>Reel</h5>
                  </div>
                </Link>
                <Link
                  to={`${process.env.PUBLIC_URL}/reel-2021`}
                  className="reels-thumb"
                  key="reel-2021"
                >
                  <div className="reels-thumb-image">
                    <ReactFreezeframe
                      src={`${process.env.PUBLIC_URL}/images/film/reel2021_2.gif`}
                    />
                  </div>
                  <div className="reels-thumb-text">
                    <h3>Estelle Collective</h3>
                    <h5>Reel</h5>
                  </div>
                </Link>
              </React.Fragment>
            }
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default CollectiveReels;
